import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";

export const useDeleteDealMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dealApi.deleteDeal,
    onSuccess: (_data, { dealUuid }) => {
      queryClient.invalidateQueries({
        queryKey: dealQueryKeys.all,
        refetchType: "none",
      });
      queryClient.invalidateQueries({ queryKey: dealQueryKeys.lists() });
      queryClient.removeQueries({
        queryKey: dealQueryKeys.detail(dealUuid),
        type: "inactive",
      });
    },
  });
};
